import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Typography from '../../../../../../components/Typography';
import { i18nNS } from '../../../../../../i18n';
import InstructorIcon from '../../../../../../icons/InstructorIcon';
import SlideIdentifier from '../SlideIdentifier';
import useManualPoll from './vm';

const ManualPoll = () => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { isPollOpen } = useManualPoll();

  if (!isPollOpen) return <SlideIdentifier />;

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <InstructorIcon size={20} color="primary" />
      <Typography variant="textXsBold" color="primary">
        {t('instructor_closes_manually', { ns: i18nNS.POLL })}
      </Typography>
    </Stack>
  );
};

export default ManualPoll;
